<div class="flex flex-nowrap items-center w-full border-b border-b-gray-100 gap-6">
  <ng-content></ng-content>
</div>
